export default __webpack_public_path__ + "static/media/sonido-notification.f686b7ef.mp3";